import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BuyActions } from 'src/app/common/store/actions/buy.actions';
import { ProposalDialogComponent } from '../proposal-dialog/proposal-dialog.component';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { selectAllProposals } from 'src/app/common/store/state/app.state';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';

import { MatIconModule } from '@angular/material/icon';
import { ObjectData } from 'src/app/public/common/models/object-data.model';


import { BuyAction, ProposalAction, BuyBasicData, ProposalStatus } from 'src/app/public/buy/constants/buy-basic-data';
import { RentAction, BookingAction } from 'src/app/public/rent/constants/rent-basic-data';
import { KeepAction, JobAction } from 'src/app/public/keep/constants/keep-basic-data';
import { Proposal } from 'src/app/public/buy/models/proposal.model';
import { Booking } from 'src/app/public/rent/models/booking.model';
import { Job } from 'src/app/public/keep/models/job.model';

import { Car } from 'src/app/public/car/models/car.model';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';

@Component({
    selector: 'app-proposals',
    templateUrl: './proposals.component.html',
    styleUrls: ['./proposals.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconModule]
})
export class ProposalsComponent {

  //@Input() proposals: Proposal[] = [];
  @Input() objectSource: ObjectSource = ObjectSource.BUY;
  @Input() offerId: string = "";
  @Input() enableNew: boolean = false;

  proposals$: Observable<Proposal[]>;
  proposals: Proposal[] = [];

  ProposalStatus = ProposalStatus;
  ObjectSource = ObjectSource;

  ProposalAction = ProposalAction;
  proposalActionItems = BuyBasicData.proposalActionItems

  constructor(
      private router: Router,
      private store: Store, 
      public dialog: MatDialog) {
      this.proposals$ = this.store.select(selectAllProposals(this.objectSource, this.offerId))
  }
     
  ngOnInit(): void {

    this.proposals$ = this.store.select(selectAllProposals(this.objectSource, this.offerId))
          
    this.proposals$.subscribe(
      (result: Proposal[]) => this.proposals = result
    );

  }
  
  openProposalDialog(proposalId: number, proposalAction?: ProposalAction): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.offerId, proposalId );

    objectData.objectAction = proposalAction;

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(ProposalDialogComponent, {
      data: objectData
    });

    /*
    if(isModification){
      let instance = dialogRef.componentInstance
      instance.isModification = isModification
    }
      */
  }

  /** 
  openProposalDialogOld(prop?: Proposal): void {
  
      //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
      let proposal: Proposal;
  
      if(prop !== undefined){
        proposal = JSON.parse(JSON.stringify(prop!));
        //console.log('hello 1')
        
      }else{
        proposal = new Proposal();
        proposal.carId = this.carId!;
        //console.log('hello 2')
      }
  
      let isReschedule: boolean = (proposal.rescheduleDate === '1'); // 1 is to indicate that reschedule has to be edited
  
      //console.log('prop = '+JSON.stringify(carId));
      const dialogRef = this.dialog.open(ProposalDialogComponent, {
        data: proposal
      });
      
      dialogRef.afterClosed().subscribe((result: Proposal) => {
  
        //console.log('helloo = '+JSON.stringify(result));
        
        if(result != undefined ){
  
          //console.log('New proposal = '+result.status+ " date = "+result.proposalDate+ " car Id = "+JSON.stringify(result));
          if(result.id === ''){
            console.log('new')
            this.store.dispatch(BuyActions.proposalNewSubmit ( { proposal: result }));
            return;
          }
  
          if(isReschedule){
            console.log('reschedule')
            this.store.dispatch(BuyActions.proposalRescheduleSubmit ( { proposalId: result.id, rescDate: result.rescheduleDate }));
            return;
          }
  
          else{
            console.log('update')
            this.store.dispatch(BuyActions.proposalUpdateSubmit ( { proposal: result }));          
            return;
          } 
        }  
      });
    }
  */
    updateProposalStatus(proposalId: number, status: ProposalStatus){
  
      //console.log('heyy   '+status.toString());
  
      this.store.dispatch(BuyActions.proposalStatusUpdateSubmit ( { proposalId: proposalId, status: status, objectSource: this.objectSource }));
  
    }

    executeProposalActionOld(proposal: Proposal, action: ProposalAction){
    
      if( [ProposalAction.EDIT, ProposalAction.EDIT_MODIF, ProposalAction.COMPLETE].includes(action) ){
        this.openProposalDialog(proposal.id, action )
      }
      else{
        this.store.dispatch(BuyActions.proposalActionSubmit ( { proposalAction: action, proposal: proposal, objectSource: this.objectSource }));  
      }
    }
    
    dateFormat(dt: string): string{
    
      return AppFunctions.stringToDatetime(dt);
    }

    moneyFormat(dt: string): string{
  
      return AppFunctions.numberWithComma(dt);
    }

    executeBuyAction(car: Car, action: BuyAction){
    
        switch(action) {
          case BuyAction.CLOSE:{
            this.store.dispatch(DealerActions.providerOfferToggleClosedSubmit(
              { carId: car.carId, providerOfferId: car.offerId, businessLine: CarBusinessLine.BUY, objectSource: this.objectSource }
            ))
            break;
          }
          case BuyAction.CREATE:{
            this.store.dispatch(DealerActions.providerOfferNewSubmit(
              { providerOffer: car, objectSource: this.objectSource }
            ))
            break;
          }
          case BuyAction.EDIT:{
            this.store.dispatch(DealerActions.providerOfferUpdateSubmit(
              { providerOffer: car, objectSource: this.objectSource }
            ))
            break;
          }
          case BuyAction.PUBLISH:{
            this.store.dispatch(DealerActions.providerOfferTogglePostedSubmit(
              { carId: car.carId, providerOfferId: car.offerId, businessLine: CarBusinessLine.BUY, objectSource: this.objectSource }
            ))
            break;
          }
          case BuyAction.SHARE:{
            break;
          }
          case BuyAction.TOGGLE_FAV:{
            break;
          }
        }
      }
    
      executeRentAction(car: Car, action: RentAction){
    
        switch(action) {
          case RentAction.CLOSE:{
            break;
          }
          case RentAction.CREATE:{
            break;
          }
          case RentAction.EDIT:{
            break;
          }
          case RentAction.PUBLISH:{
            break;
          }
          case RentAction.SHARE:{
            break;
          }
          case RentAction.TOGGLE_FAV:{
            break;
          }
        }
      }
    
      executeKeepAction(car: Car, action: KeepAction){
    
        switch(action) {
          case KeepAction.CLOSE:{
            break;
          }
          case KeepAction.CREATE:{
            break;
          }
          case KeepAction.EDIT:{
            break;
          }
          case KeepAction.PUBLISH:{
            break;
          }
          case KeepAction.SHARE:{
            break;
          }
          case KeepAction.TOGGLE_FAV:{
            break;
          }
        }
      }
    
      executeProposalAction(proposal: Proposal, action: ProposalAction){
    
        switch(action) {

          case ProposalAction.CREATE, ProposalAction.EDIT, ProposalAction.EDIT_MODIF:{
            this.openProposalDialog(proposal.id, action )
            break;
          }
          default:{
            this.store.dispatch(BuyActions.proposalActionSubmit ( { proposalAction: action, proposal: proposal, objectSource: this.objectSource }));
            break;
          }
        }
      }
    
      executeBookingAction(booking: Booking, action: BookingAction){
    
        switch(action) {
          case BookingAction.ACCEPT_MODIF:{
            break;
          }
          case BookingAction.CANCEL:{
            break;
          }
          case BookingAction.CANCEL_MODIF:{
            break;
          }
          case BookingAction.COMPLETE:{
            break;
          }
          case BookingAction.CONFIRM:{
            break;
          }
          case BookingAction.EDIT_MODIF:{
            break;
          }
          case BookingAction.EDIT:{
            break;
          }
          case BookingAction.REOPEN:{
            break;
          }
          case BookingAction.SEND:{
            break;
          }
        }
      }
    
      executeJobAction(job: Job, action: JobAction){
    
        switch(action) {
          case JobAction.ACCEPT:{
            break;
          }
          case JobAction.ACCEPT_MODIF:{
            break;
          }
          case JobAction.CANCEL:{
            break;
          }
          case JobAction.CANCEL_MODIF:{
            break;
          }
          case JobAction.COMPLETE:{
            break;
          }
          case JobAction.CREATE:{
            break;
          }
          case JobAction.EDIT:{
            break;
          }
          case JobAction.EDIT_MODIF:{
            break;
          }
          case JobAction.REJECT:{
            break;
          }
          case JobAction.REJECT_MODIF:{
            break;
          }
          case JobAction.REOPEN:{
            break;
          }
          case JobAction.SEND:{
            break;
          }
        }
      }

}
